/** Where the real marketing homepage lives.
 *
 *  While pre-launch mode is on, "/" is the branded launch page and the marketing
 *  homepage (with the Season Pass pricing section) sits at the unlisted /beta slug.
 *  Anything linking to a homepage section has to go through here, or it lands on
 *  the pre-launch page instead.
 */
export const PRELAUNCH = process.env.REACT_APP_PRELAUNCH_MODE === 'true';

export const MARKETING_HOME = PRELAUNCH ? '/beta' : '/';

export const homeSection = (id) => `${MARKETING_HOME}#${id}`;
